import { Routes } from '@angular/router';
import { RegisterComponent } from './pages/register/shell/register/register.component';

export const routes: Routes = [
  {path: 'register', component: RegisterComponent},
  {path: '', redirectTo: '/register', pathMatch: 'full' },
  {path: '**', redirectTo: '/register' ,pathMatch: 'full'}
];
